type Values<T> = T[keyof T];

function typedKeys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>;
}

export function createEnumFactoryWithSchema<S extends Record<string, unknown>>() {
  return function <const T extends Record<string, S>>(obj: T) {
    const keys = typedKeys(obj);

    const types = keys.reduce((acc, key) => {
      const entry = obj[key];
      return {
        ...acc,
        [key]: { value: key, ...entry },
      };
    }, {} as { [K in keyof T]: { value: K & string } & T[K] });

    type EnumObject = typeof types;
    type EnumKeys = Extract<keyof EnumObject, string>;
    type EnumUnion = Values<EnumObject>;

    return {
      types,
      keys,
      union: null as unknown as EnumUnion,
      isKey: (key: string): key is EnumKeys => keys.includes(key as EnumKeys),
      entries: keys.map((key) => [key, obj[key]]) as [EnumKeys, T[EnumKeys]][],
    };
  };
}
